export enum AppFeedbackType {
  Updates = 'Updates',
  Suggestions = 'Suggestions',
}

export enum ImplementationState {
  Suggested = 'Suggested',
  Reviewed = 'Reviewed',
  InDevelopment = 'In Development',
  Live = 'Live',
  Backlog = 'Backlog',
  Bug = 'Bug',
  Fixed = 'Fixed',
}

export class Feedback {
  uid = '';
  feedback = {
    upvotes: 0,
    downvotes: 0,
  };
  createdAt: Date = new Date();
  content: string = '';
  creatorUID: string = '';
  implementationState: ImplementationState = ImplementationState.Suggested;

  public constructor(init?: Partial<Feedback>) {
    // Set default values
    const defaults = {
      createdAt: new Date().toISOString(),
      uid: null,
      content: '',
      creatorUID: '',
      implementationState: ImplementationState.Suggested,
      feedback: {
        upvotes: 0,
        downvotes: 0,
      },
    };

    // Merge defaults with provided values
    Object.assign(this, defaults, init);

    // Ensure votes are initialized
    if (!this.feedback) {
      this.feedback = { upvotes: 0, downvotes: 0 };
    }
  }
}
